import { SpherePlatformAppPaths } from '@sphere/platform';

export const KPLER_TRADE_FLOWS_SEARCH = 'trade-flow-search';
export const KPLER_SNAPSHOTS = 'snapshots';
export const KPLER_FLOWS_DASHBOARD = 'flows-dashboard';
export const KPLER_FLEET_METRICS = 'fleet-metrics';

export const PATHS: SpherePlatformAppPaths = {
    ['KPLER_TRADE_FLOWS_SEARCH']: 'trade-flow-search',
    ['KPLER_SNAPSHOTS']: 'snapshots',
    ['KPLER_FLOWS_DASHBOARD']: 'flows-dashboard',
    ['KPLER_FLEET_METRICS']: 'fleet-metrics'
};
